import React, { useMemo } from "react"
import CategoryPC from '@modules/Category/CategoryPC'
import CategoryM from '@modules/Category/CategoryM'
import { getQueryFromUrl } from '@lib/utils'

const Category = (props: any) => {
  const { keyword, pathname, total, products, selectedWords, suggests, relatedArticles } = props.pageContext || {}
  const _keyword = useMemo(() => {
    if (keyword) {
      return keyword
    }
    return getQueryFromUrl() || ' '
  }, [keyword])
  return (
    <div>
      <CategoryPC pathname={pathname} suggests={suggests} selectedWords={selectedWords} products={products} total={total} keyword={_keyword} relatedArticles={relatedArticles} />
      <CategoryM suggests={suggests} selectedWords={selectedWords} products={products} total={total} keyword={_keyword} relatedArticles={relatedArticles} />
    </div>
  )

}
export default Category
